module.exports = __webpack_public_path__ + "images/backgrounds/mountain/large.46616ebeae7245d4a16c.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/mountain/large.jpg
// module id = rP79
// module chunks = 12